var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:`tutorial-block variant-${_vm.variant}`,style:({ backgroundImage: _vm.backgroundImage }),attrs:{"to":_vm.to}},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('h4',[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }